<template>
  <div class="loading">
    <div class="loading-outline">
      <div class="loading-bar">
        <span class="loading-text">loading...</span>
      </div>
    </div>
  </div>
</template>

<script startup async>
export default {
  name: 'loading',
  props: ['time'],
  mounted () {
    this.$el.style.setProperty('--time', `${this.time}ms`)
    setTimeout(() => this.$el.parentNode.removeChild(this.$el), parseInt(this.time) + 100)
  }
}
</script>

<style>
.loading {
  --bg-color: rgba(14,13,20,1);
  --accent-color: rgba(171,50,52,1);
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0px;
  left: 0px;
  background-color: var(--bg-color);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 10;
  opacity: 1;
  animation: fade .1s linear var(--time) forwards;
}

@keyframes fade {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.loading-outline {
  width: 70vw;
  height: 20vh;
  background-color: var(--accent-color);
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-bar {
  width: 95%;
  height: 80%;
  background-color: var(--accent-color);
  border: 10px solid var(--bg-color);
  clip-path: inset(0 100% 0 0);
  animation: bar-grow var(--time) ease-in-out 0s forwards;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 75px;
  font-family: monospace;
}

@keyframes bar-grow {
  from {
    clip-path: inset(0 100% 0 0);
  }
  to {
    clip-path: inset(0 0 0 0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/loading.vue